import { useEffect, useState } from 'react';
import styles from './UnderwritingStatus.module.scss'
import { RestS } from '../../../rest/rest-service';
import { useNavigate, useOutletContext } from 'react-router';
import { LendingStatus, LinkType } from '../../../interfaces/interfaces';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import SuccessMockupImg from '../../../assets/images/supplierPayments/underwriting - success 4x webp no shadow.webp';
import SuccessTopShadow from '../../../assets/images/supplierPayments/success 1x top shadow svg.svg';
import usePageTitle from '../../../components/Hooks/usePageTitle';
import HeaderTitle from '../../../components/common/HeaderTitle';


const UnderwritingStatus = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const fetchFormData = async () => {
        try {
            const response: any = await RestS.fetchUnderwritingFormData();
            // console.log('formResponse', response);
            return response;
        } catch (error) {
            console.log('error', error);
        }
    }
    const pageTitle = usePageTitle('Merito Credit | Merito');
    const { setHeaderContent, resetHeaderContent } = useOutletContext<any>();

    useEffect(() => {
        setHeaderContent(
            <HeaderTitle isNav={false} headerTitle={`Merito Credit`} />
        );
        return () => {
            resetHeaderContent();
        };
    }, []);

    useEffect(() => {

        // if (update?.updateAvailable) {
        const bodyElement = document.getElementsByTagName("body")[0];
        bodyElement.style.overflowY = "hidden";
        const pageIndexLayout: any = document.getElementById("page_body");
        if (pageIndexLayout) {
            // pageIndexLayout.style.overflowY = "hidden";
            pageIndexLayout.style.padding = "0rem";
        }

        return () => {
            const bodyElement = document.getElementsByTagName("body")[0];
            const pageIndexLayout: any = document.getElementById("page_body");
            if (pageIndexLayout) {
                pageIndexLayout.style.overflowY = "scroll";
                pageIndexLayout.style.padding = "1rem 1.5rem 2rem 1.5rem";
            }
            pageTitle('')
        };
        // }
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const data: any = await RestS.checkInviteType(LinkType.underwriting);
                console.log('data', data);
                if (!data?.isAccess) {
                    navigate('/404', {
                        replace: true
                    })
                }
                const response = await fetchFormData();
                const { formData } = response;
                const pendingStatus = new Set([LendingStatus.APPROVED, LendingStatus.PENDING_APPROVAL, LendingStatus.REJECTED]);

                if (!pendingStatus.has(formData?.applicationStatus)) {
                    navigate('/underwriting')
                }

            } catch (error) {
                console.log('error', error)

            } finally {
                setLoading(false)
            }
        })();
    }, [])


    return (
        <div className={styles.underwritingRootContainer}>
            {loading ?
                <div className={styles.loadingContainer}>
                    <CircularLoader />
                </div> :
                <>
                    <div className={styles.leftContainer}>
                        <div className={styles.titleContainer}>
                            <div className={styles.title}>
                                Your Application Is <br /> Being Reviewed!
                            </div>
                            <div className={styles.subTitle}>
                                Thank you for your submission. <br /> We’ll get back to you shortly.
                            </div>
                        </div>
                    </div>

                    <div className={styles.rightContainer}>
                        <div className={styles.imgContainer}>
                            <img className={styles.topShadowImg} src={SuccessTopShadow} />
                            <img className={styles.landingImg} src={SuccessMockupImg} alt="" />

                        </div>
                    </div>
                </>
            }
        </div>
    );
}

export default UnderwritingStatus